<div class="d-flex justify-content-center px-0 mx-0 mt-5" *ngIf="user">
  <div class="col px-1 col-lg-8">
    <!-- HEADER -->
    <div class="d-flex justify-content-between align-items-center bg-secondary text-white p-3">
      <label class="fs-5 m-0"><span class="vag-bold-font text-uppercase">ÁREA DEL TUTOR </span>Mi cuenta</label>
      <button (click)="logout()" type="button" class="d-inline-flex btn btn-outline text-white">
        <label class="d-none d-md-block mr-3 fs-5">Salir</label>
        <fa-icon [icon]="powerOffIcon" size="lg" class="text-white"></fa-icon>
      </button>
    </div>

    <!-- CONTENT -->
    <div class="d-block d-lg-flex mx-0 px-0 content-area">
      <div class="d-none d-lg-block col-12 col-lg-4 pl-0 pb-3">
        <div class="profile"
          [ngClass]="{'selected': menuItemChoosen === 'profile', 'regular': menuItemChoosen !== 'profile'}"
          (click)="menuItemShown('profile')">
          <div class="text text-center">
            <p class="vag-bold-font mb-0">{{user.fullname}}</p>
            <span>{{user.numberDNI}}</span>
          </div>
        </div>
        <div class="d-flex align-items-center menu-item mb-2 border menuItem"
          [ngClass]="{'bg-active': menuItemChoosen === 'students'}" (click)="menuItemShown('students')">
          <img src="../../assets/img/alumnos.PNG">
          <div class="ml-3">
            Alumnos
          </div>
        </div>
        <div class="d-flex align-items-center menu-item mb-2 border menuItem"
          [ngClass]="{'bg-active': menuItemChoosen === 'academic'}" (click)="menuItemShown('academic')">
          <img src="../../assets/img/academico.PNG">
          <div class="ml-3">
            Académico
          </div>
        </div>
        <div class="d-flex align-items-center menu-item mb-2 border menuItem"
          [ngClass]="{'bg-active': menuItemChoosen === 'evaluations'}" (click)="menuItemShown('evaluations')">
          <img src="../../assets/img/evaluaciones.PNG">
          <div class="ml-3">
            Evaluaciones
          </div>
        </div>
        <div class="d-flex align-items-center menu-item mb-2 border menuItem"
          [ngClass]="{'bg-active': menuItemChoosen === 'documents'}" (click)="menuItemShown('documents')">
          <img src="../../assets/img/documentos.PNG">
          <div class="ml-3">
            Documentos
          </div>
        </div>
        <div class="d-flex align-items-center menu-item mb-2 border menuItem"
          [ngClass]="{'bg-active': menuItemChoosen === 'billing'}" (click)="menuItemShown('billing')">
          <img src="../../assets/img/facturacion.PNG">
          <div class="ml-3">
            Facturación
          </div>
        </div>
      </div>
      <div class="d-block d-lg-block col col-lg-8 pr-0 pl-0 pl-lg-3 m-0">
        <div class="profile-user" *ngIf="menuItemChoosen === 'profile'">
          <div class="d-lg-flex my-2">
            <div class="px-0 col col-lg-6 my-2">
              <div class="d-block text-lg">
                <div class="vag-bold-font">
                  Dirección
                </div>
                <div>
                  {{ user.address }} {{user.number}} {{user.municipality}}, Sevilla
                  <!--<img class="lapiz" src="../../assets/img/lapiz.PNG" width="24"
                    (click)="modificar('Dirección', 'EDITAR', direccion)">-->
                </div>
              </div>
            </div>
          </div>
          <div class="d-lg-flex my-2">
            <div class="px-0 col col-lg-6 my-2">
              <div class="d-block text-lg">
                <div class="vag-bold-font">
                  Teléfono móvil
                </div>
                <div>
                  {{ user.phone1 }}
                  <!--<img class="lapiz" src="../../assets/img/lapiz.PNG" width="24"
                    (click)="modificar('Móvil', 'EDITAR', movil)">-->
                </div>
              </div>
            </div>
            <div class="px-0 col col-lg-6 my-2">
              <div class="d-block text-lg">
                <div class="vag-bold-font">
                  Teléfono secundario
                </div>
                <div>
                  {{ user.phone2 }} 
                  <!--<img class="lapiz" src="../../assets/img/lapiz.PNG" width="24"
                    (click)="modificar('Teléfono', 'EDITAR', telefono)">-->
                </div>
              </div>
            </div>
          </div>
          <div class="d-block my-2 text-lg">
            <div class="vag-bold-font">Email</div>
            <div>{{ user.email }}
              <!--<img class=" lapiz" src="../../assets/img/lapiz.PNG" width="24"
                (click)="modificar('Email', 'EDITAR', email, true)">-->
            </div>
          </div>
          <div class="d-block my-2 text-lg">
              <br>
              <div class="vag-bold-font">CALENDARIO ESCOLAR 2021-22</div>
              <b>6 de septiembre.</b> Inicio del curso escolar.<br/>
              <b>12 de octubre.</b> Fiesta Nacional de España.<br/>
              <b>1 de noviembre.</b> Festividad de todos los Santos.<br/>
              <b>6 de diciembre.</b> Día de la Constitución.<br/>
              <b>8 de diciembre.</b> Día de la Inmaculada.<br/>
              <b>23 de diciembre.</b> Taller de recuperación I.<br/>
              <b>24 de diciembre - 9 de enero.</b> Vacaciones Navidad.<br/>
              <b>25 de febrero.</b> Día de la Comunidad Educativa.<br/>
              <b>28 de febrero.</b> Día de Andalucía.<br/>
              <b>11 - 17 de abril.</b> Vacaciones Semana Santa.<br/>
              <b>23 de abril.</b> Taller de recuperación II.<br/>
              <b>2 de mayo.</b> Festividad del Día del Trabajo 1 de mayo.<br/>
              <b>25 de junio.</b> Taller de recuperación III.<br/>
              <b>30 de junio.</b> Fin del curso escolar.<br/>
          </div>
        </div>
        <div *ngIf="menuItemChoosen === 'students'">
          <app-student *ngIf="user" [user]="user" [students]="students"> </app-student>
        </div>
        <div *ngIf="menuItemChoosen === 'academic'">
          <app-academic *ngIf="user" [user]="user" [students]="students"> </app-academic>
        </div>
        <div *ngIf="menuItemChoosen === 'evaluations'" class="evaluations">
          <app-evaluations *ngIf="user" [user]="user" [students]="students" (propagar)="pintarBoletin($event)">
          </app-evaluations>

        </div>
        <div *ngIf="menuItemChoosen === 'documents'">
          <app-documents *ngIf="user" [user]="user" [students]="students" (propagar)="procesarDocumento($event)">
          </app-documents>
        </div>
        <div *ngIf="menuItemChoosen === 'billing'">
          <app-billing *ngIf="user" [user]="user" [students]="students" (propagar)="checkoutBilling($event)"
            (verPdf)="getIdReceiptImprimir($event)"></app-billing>
        </div>
      </div>
      <div class="d-flex flex-column d-lg-none col-12 mt-2">
        <div class="d-flex d-lg-none fixed-bottom px-1 mt-2 pt-2 bg-white">
          <div class="d-flex col align-items-center justify-content-center mx-1 p-0 bg-lightblue"
            [ngClass]="{'opacity-3': menuItemChoosen !== 'profile'}" (click)="menuItemShown('profile')">
            <fa-icon [icon]="userIcon" size="2x" class="text-white"></fa-icon>
          </div>
          <div class="col mx-1 p-0"
            [ngClass]="{'selected': menuItemChoosen === 'students', 'regular': menuItemChoosen !== 'students'}"
            (click)="menuItemShown('students')"><img [ngClass]="{'opacity-3': menuItemChoosen !== 'students'}"
              src="../../assets/img/alumnos.PNG" width="100%"></div>
          <div class="col mx-1 p-0" [ngClass]="{'bg-active': menuItemChoosen === 'academic'}"
            (click)="menuItemShown('academic')"><img [ngClass]="{'opacity-3': menuItemChoosen !== 'academic'}"
              src="../../assets/img/academico.PNG" width="100%"></div>
          <div class="col mx-1 p-0"
            [ngClass]="{'selected': menuItemChoosen === 'evaluations', 'regular': menuItemChoosen !== 'evaluations'}"
            (click)="menuItemShown('evaluations')"><img [ngClass]="{'opacity-3': menuItemChoosen !== 'evaluations'}"
              src="../../assets/img/evaluaciones.PNG" width="100%"></div>
          <div class="col mx-1 p-0"
            [ngClass]="{'selected': menuItemChoosen === 'documents', 'regular': menuItemChoosen !== 'documents'}"
            (click)="menuItemShown('documents')"><img [ngClass]="{'opacity-3': menuItemChoosen !== 'documents'}"
              src="../../assets/img/documentos.PNG" width="100%"></div>
          <div class="col mx-1 p-0"
            [ngClass]="{'selected': menuItemChoosen === 'billing', 'regular': menuItemChoosen !== 'billing'}"
            (click)="menuItemShown('billing')"><img [ngClass]="{'opacity-3': menuItemChoosen !== 'billing'}"
              src="../../assets/img/facturacion.PNG" width="100%"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- generar boletín-->
<div id="boletinpdf" [hidden]="showPdf" *ngIf="courseCurrent && this.periodEvaluation " class="boletin-pdf">
  <div class="container-fluid content-wrapper">
    <div class="pdf-header">
      <div class="titulo-boletin">Boletín de evaluaciones</div>
    </div>
    <div class="logo-header">
      <img src="/assets/img/documentos/logo_playbots.png" />
    </div>
    <div class="info-alumno text-img-pdf">
      <p>Alumno/a: <span style="text-transform: uppercase;">{{students[studentCurrent]?.fullname}}</span></p>
      <p>Curso: <span>{{courseCurrent?.description}}</span></p>
      <p>Centro:<span> {{ courseCurrent?.centerDescr}}
          - <span style="font-weight: normal;"> Grupo:</span> {{courseCurrent?.code}}</span></p>
      <p>Año académico: <span style="text-transform: capitalize;">{{ 'name' | filterObservable :
          courseCurrent?.period | async }}
          - <span style="font-weight: normal;"> Evaluación:</span> {{periodEvaluation}}</span></p>
    </div>
    <div class="row">
      <div class="col-8 chart-card" style="padding-left: 40px; height: 12px;">
        <div>
          <div class="chart-card-body bar-vertical" style="padding-bottom: 240px;">
            <ngx-charts-bar-vertical *ngIf="isBrowser" [scheme]="colorScheme" [results]="countriesData"
              [gradient]="verticalBarOptions.gradient" [xAxis]="verticalBarOptions.showXAxis"
              [yAxis]="verticalBarOptions.showYAxis" [legend]="verticalBarOptions.showLegend"
              [showXAxisLabel]="verticalBarOptions.showXAxisLabel" [showYAxisLabel]="verticalBarOptions.showYAxisLabel"
              [xAxisLabel]="verticalBarOptions.xAxisLabel" [yAxisLabel]="verticalBarOptions.yAxisLabel"
              [barPadding]="verticalBarOptions.barPadding" [yScaleMax]="5"
              [showGridLines]="verticalBarOptions.showGridLines">
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>
      <div class="col-5" style="margin-left: 426px; margin-top: -14px; padding-left: 20px; background-color: white;">
        <div class="row" style="width: 400px;">
          <div class="col-2">
            <img src="/assets/img/documentos/copa_oro.png" style="width: 58px; height: 72px;" />
          </div>
          <div class="col-10 text-img-pdf">
            <p class="project-pdf">
              Temática: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][0]">
                {{ 'name' | filterObservable : ('monthlyThematic' | filterObservable :
                projectWinner[periodEvaluation][0]?.projectSaved | async ) | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][0]">
                No hay temática
              </span>
            </p>
            <p class="project-pdf">
              Proyecto: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][0]">
                {{ 'project' | filterObservable : projectWinner[periodEvaluation][0]?.projectSaved | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][0]">
                No hay proyecto
              </span>
            </p>
            <p class="project-pdf">
              Área: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][0]">
                {{ 'name' | filterObservable : ('projectType' | filterObservable :
                projectWinner[periodEvaluation][0]?.projectSaved | async ) | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][0]">
                No hay área
              </span>
            </p>
          </div>
        </div>
        <div class="row" style="margin-top: 20px; width: 400px;">
          <div class="col-2">
            <img src="/assets/img/documentos/copa_plata.png" style="width: 58px; height: 72px;" />
          </div>
          <div class="col-10 text-img-pdf">
            <p class="project-pdf">
              Temática: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][1]">
                {{ 'name' | filterObservable : ('monthlyThematic' | filterObservable :
                projectWinner[periodEvaluation][1]?.projectSaved | async ) | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][1]">
                No hay temática
              </span>
            </p>
            <p class="project-pdf">
              Proyecto: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][1]">
                {{ 'project' | filterObservable : projectWinner[periodEvaluation][1]?.projectSaved | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][1]">
                No hay proyecto
              </span>
            </p>
            <p class="project-pdf">
              Área: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][1]">
                {{ 'name' | filterObservable : ('projectType' | filterObservable :
                projectWinner[periodEvaluation][1]?.projectSaved | async ) | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][1]">
                No hay área
              </span>
            </p>
          </div>
        </div>
        <div class="row" style="margin-top: 20px; width: 400px;">
          <div class="col-2">
            <img src="/assets/img/documentos/copa_bronce.png" style="width: 58px; height: 72px;" />
          </div>
          <div class="col-10 text-img-pdf">
            <p class="project-pdf">
              Temática: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][2]">
                {{ 'name' | filterObservable : ('monthlyThematic' | filterObservable :
                projectWinner[periodEvaluation][2]?.projectSaved | async ) | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][2]">
                No hay temática
              </span>
            </p>
            <p class="project-pdf">
              Proyecto: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][2]">
                {{ 'project' | filterObservable : projectWinner[periodEvaluation][2]?.projectSaved | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][2]">
                No hay proyecto
              </span>
            </p>
            <p class="project-pdf">
              Área: <span *ngIf="projectWinner[periodEvaluation] && projectWinner[periodEvaluation][2]">
                {{ 'name' | filterObservable : ('projectType' | filterObservable :
                projectWinner[periodEvaluation][2]?.projectSaved | async ) | async }}
              </span>
              <span *ngIf="!projectWinner[periodEvaluation] || !projectWinner[periodEvaluation][2]">
                No hay área
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="label-grafico">
      <img src="/assets/img/documentos/labels.PNG" />
    </div>
    <div class="pdf-notas">{{students[studentCurrent].notasEvaluation['course_' + this.courseCurrent.id][periodEvaluation]}}</div>
    <div class="pdf-footer">
      <div class="text-footer-centro">
        Centro {{courseCurrent?.centerDescr }}
      </div>
    </div>
    <div class="texto-footer">
      Centros Educativos Playbots · Avda. de las Civilizaciones 15, local 9 · Mairena del Aljarafe · Sevilla ·
      info@playbots.es · +34 854 993 164
    </div>
  </div>
</div>
<!-- Generar contrato-->
<div id="pdfContent" [hidden]="showPdfContrato" *ngIf="courseCurrent">
  <div class="pdfContent-title-center"><b>CONTRATO DE PRESTACIÓN DE SERVICIOS DE ENSEÑANZA NO REGLADA</b></div>
  <div class="pdfContent-file-center"><b>REUNIDOS:</b></div>
  <p>De una parte, D. Mario Velázquez Cardellat, mayor de edad, con DNI 28604621G, quien actúa como administrador único
    en nombre y
    representación de la entidad PLAYBOTS EDUCATION S.L., domiciliada en Avenida de las Civilizaciones 15 - Local 9,
    Mairena del Aljarafe,
    Sevilla y CIF B90351719.</p>
  <p>Y de la otra, D./Dª <b style="text-transform: uppercase;">{{ fullName }}</b> mayor de edad, y vecino de
    {{ municipality }}, con domicilio en <span style="text-transform: uppercase;">{{ address }}</span> y <span
      style="text-transform: uppercase;">{{ dniDocument }}</span>,
    quien actúa en nombre y representación de su hijo/a menor de edad <b style="text-transform: uppercase;">{{
      this.students[this.studentCurrent].firstname }} {{ this.students[this.studentCurrent].lastname }}</b>,
    de igual vecindad y domicilio que el anterior. Teniendo las partes la capacidad legal necesaria para otorgar el
    presente contrato de enseñanza, y suscribir el
    documento que lo contiene, lo hacen con arreglo a las siguientes bases y condiciones: </p>

  <div class="pdfContent-file-center"><b>BASES</b></div>
  <p>PRIMERA.- Que PLAYBOTS EDUCATION S.L. se dedica a la enseñanza privada en sus centros asociados y entre su oferta
    dispone de cursos para la
    enseñanza de Robótica y Programación Educativa STEAM. Se trata de enseñanza privada, y por tanto el título o diploma
    carece de eficacia oficial.</p>

  <p>SEGUNDA.- Que D./Dª {{fullName}} desea recibir dichos servicios docentes para su hijo/a
    {{this.students[this.studentCurrent].firstname}} {{this.students[this.studentCurrent].lastname}},
    con arreglo a las siguientes condiciones:</p>

  <div class="pdfContent-file-center"><b>CONDICIONES ESPECIALES</b></div>
  <p>PRIMERA.- El centro de formación prestará al alumno sus servicios docentes y clases durante el siguiente horario:
    <b>{{nombreCentro}} {{day}} de {{horarioSelected}}</b>
  </p>
  <p>SEGUNDA.- El programa y plan de estudios del curso <span
      style="text-transform: uppercase; font-weight: bold;">{{courseCurrent.description}}</span>,
    que se desarrollará bajo la
    supervisión de un tutor/profesor, tiene fecha de finalización el
    {{dateFormat(courseCurrent.endDate)}}y se desarrollará con arreglo al siguiente esquema: una (1) clase
    semanal de noventa (90) minutos durante todo el curso escolar desde la fecha de inscripción a junio, excluyendo los
    periodos vacacionales, Navidad y Semana Santa,
    así como los días festivos marcados en el <b>CALENDARIO ESCOLAR DE SEVILLA</b></p>
  <p>El curso consta de sesenta (60) horas lectivas, a razón de 6 horas mensuales. En caso de realizar la matrícula con
    el curso iniciado, las horas lectivas se
    calcularán proporcionalmente.</p>
  <p>Las clases que coincidan con festivos locales, regionales o nacionales, podrán ser recuperadas, siempre que sea
    posible, dentro de la misma semana del festivo en
    cuestión, asegurando así la homogeneidad del temario. Las faltas de asistencia no acreditadas se considerarán
    injustificadas y no serán objeto de recuperación.
  </p>
  <p>TERCERA.- La formación a que se refiere el presente contrato requiere, además de las clases, el siguiente material
    didáctico:</p>
  <p>Elementos propios de la escuela, que forman parte de los servicios que integran el curso y que se entregan al
    alumno al comienzo de las clases
    (o en el momento que se especifique), y cuyo precio se fija separadamente en la condición siguiente.</p>

  <p>CUARTA.- El precio total anual de tales servicios docentes es de quinientos ochenta euros (580 €), o parte
    equivalente, que corresponden a los siguientes conceptos:</p>

  <p>a. Reserva de plaza: cincuenta y cinco euros (55 €) Reembolsable en la primera mensualidad<br />
    b. Inscripción: treinta euros (30 €). No reembolsable en caso de cancelación anticipada.<br />
    c. Mensualidad: cincuenta y cinco euros (55 €)</p>

  <p>QUINTA.- Los precios indicados en la cláusula anterior serán pagados por una de las dos fórmulas alternativas
    siguientes, a elección del alumno
    (o su representante).</p>

  <ul style="list-style: none;">
    <li> Con tarjeta débito/crédito</li>
    <li>Domiciliación bancaria </li>
  </ul>

  <p>SEXTA.- Pago con tarjeta</p>
  <p>El alumno (o su representante) que seleccione Tarjeta como método de pago, abonará online, a través de la pasarela
    de pago, la primera mensualidad o parte
    equivalente, así como el importe íntegro de la cuota de inscripción.<br> Para el abono de las siguientes
    mensualidades, recibirá un enlace de pago (SMS/Email)
    al inicio de cada mes.
  </p>

  <p>SÉPTIMA.- Domiciliación bancaria</p>
  <p>El alumno (o su representante) que seleccione Domiciliación bancaria como método de pago, deberá completar un
    formulario SEPA para autorizar los cargos bancarios.
    La no entrega del formulario tendrá como consecuencia la anulación de la Matrícula. Las remesas se llevan a cabo
    entre los días 1 y 7 de cada mes, excepto la
    primera mensualidad o parte equivalente, así como el importe de la cuota de inscripción, que se abonará en el
    momento de realizar la Matrícula.
  </p>

  <div class="html2pdf__page-break"></div>
  <p>OCTAVA.- Descuento unidad familiar</p>
  <p>Se aplicará un 10% de descuento sobre el importe de la mensualidad, al segundo y sucesivos alumnos matriculados de
    la misma unidad familiar.</p>

  <p>NOVENA.- Promoción Tarjeta 5</p>
  <p>El alumno (o su representante) que seleccione Tarjeta como método de pago, podrá beneficiarse de un descuento de 5€
    en la mensualidad del curso.
    El descuento se aplica automáticamente a los recibos abonados mediante enlace de pago (SMS/Email) entre los días 1 y
    5 de cada mes.</p>

  <p class="pdfContent-file-center"><b>CONDICIONES GENERALES</b></p>

  <p>PRIMERA.- Reserva de plaza</p>
  <p>Cuando se contraten los servicios de enseñanza antes de la fecha del comienzo de las clases del curso, se abonará,
    en concepto de reserva de plaza,
    la cantidad establecida en el pliego de condiciones especiales del presente contrato. La cuantía por este concepto
    no será superior al 25% del curso, y
    se devolverá o compensará al realizar el pago total del curso.</p>

  <p>SEGUNDA.- Pago mensualidades</p>

  <p>a. Las cuotas en las que difiere el pago del presente contrato, se abonarán por mensualidades adelantadas, dentro
    de los siete primeros días de cada mes,
    mediante domiciliación o tarjeta bancaria.</p>
  <p>b. El retraso por parte del alumno (o su representante) que demore en más de diez (10) días el pago de las
    cantidades mensuales mencionadas, dará lugar al devengo
    del interés legal del dinero, o el ejercicio por parte de la escuela de la facultad de resolver el contrato..</p>
  <p>c. Los gastos derivados de las devoluciones de recibos domiciliados deberán ser abonados por el alumno o su
    representante designado.</p>

  <p>TERCERA.- Duración del contrato</p>
  <p>a. La duración del presente contrato es la prevista para el plan de estudios objeto del mismo, y que se refleja en
    el pliego de condiciones especiales.
    No obstante, si por causas de fuerza mayor no imputables al centro de formación, hubiera de suspenderse el servicio,
    dicho centro lo comunicará al alumno a la
    mayor brevedad posible, reintegrando al alumno (o su representante) la parte proporcional de todas las cantidades ya
    abonadas que correspondan a servicios
    pendientes de ejecución.
  </p>

  <p>
    b. Playbots se reserva el derecho, por razones económicas y organizativas, a cancelar en cualquier momento los
    grupos que no cuenten con un mínimo de alumnos.
    El alumno podrá cambiar, dentro de las alternativas disponibles, de curso y/o centro sin coste alguno, o solicitar
    el reintegro de las cantidades ya abonadas que
    correspondan a servicios pendientes de ejecución.</p>
  <p>
    c. El alumno que abandone el curso, por cualquier causa ajena a su voluntad, debidamente acreditada, que le impida
    la prosecución del mismo, deberá comunicarlo por escrito,
    y tendrá derecho al reembolso de la parte proporcional de las cantidades abonadas en concepto de honorarios y que
    correspondan a servicios pendientes de ejecución,
    pero no del importe de la cuota de inscripción.
  </p>
  <p>Asimismo, aquellos alumnos que sin causa justificada deseen finalizar la prestación de servicios objeto del
    presente contrato, deberán notificarlo al centro por
    escrito con quince (15) días de antelación.</p>

  <p>CUARTA.- Reintegros</p>
  <p>En caso de que, por causa de fuerza mayor, el alumno se viera en la necesidad de no iniciar las clases objeto del
    contrato, el centro reintegrará al mismo el
    importe íntegro de las cantidades ya pagadas.
  </p>

  <p>QUINTA- Expedición de diplomas acreditativos</p>
  <p>A la finalización del contrato, cualquiera que sea la causa que la motive, el centro expedirá al alumno un Diploma
    acreditativo de los conocimientos adquiridos o
    nivel alcanzado. Si el nivel de conocimientos no fuere satisfactorio, el centro expedirá un certificado de
    asistencia, con expresión de la carga docente cursada.</p>

  <p>SEXTA.- Reclamaciones</p>
  <p>a. El centro tiene a disposición del alumno (o su representante) Hojas de Reclamaciones conforme al modelo oficial,
    en su caso.</p>
  <p>b. Para cualquier controversia que se derive de la interpretación o cumplimiento del presente contrato, el
    empresario expresamente se somete al sistema arbitral
    de consumo, a través de la Junta Arbitral de Consumo que corresponda al Centro que imparte la enseñanza.</p>

  <p>SÉPTIMA.- Derecho de revocación</p>

  <p>En el caso que la contratación se efectúe fuera del establecimiento mercantil, bien por el propio empresario, bien
    por un tercero que actúe por su cuenta, el alumno
    (o representante) dispone de un plazo de siete (7) días naturales, contados desde la recepción de los materiales del
    curso, para desistir del contrato,
    con derecho al reintegro de la totalidad de las cantidades abonadas, sin cumplimentar formalidad alguna, y sin que
    ello suponga penalización alguna.</p>

  <p>OCTAVA.- Derecho de desistimiento</p>
  <p>En el caso que la contratación se efectúe sin la presencia física simultánea del empresario y del alumno (o
    representante), mediante la utilización de una técnica
    de comunicación a distancia, el alumno (o representante) disponen de un plazo de siete (7) días hábiles (con arreglo
    al calendario oficial de su domicilio) para
    desistir del contrato, con derecho al reintegro de la totalidad de las cantidades abonadas, sin cumplimentar
    formalidad alguna salvo la comunicación escrita al
    centro, y sin que ello suponga penalización alguna.
  </p>

  <p>NOVENA.- Consentimiento para envío publicitario</p>
  <p>Le comunicamos que sus datos serán utilizados con fines comerciales, promocionales, publicitarios y de marketing de
    los productos y servicios que se oferten por
    parte de nuestra entidad y nunca serán cedidos a terceros.</p>

  <p>DÉCIMA.- Consentimiento para recabar datos personales</p>
  <p>De conformidad con los artículo 7 y 13 del Reglamento Europeo 2016/679 (RGDP) del Parlamento Europeo y del Consejo
    de 27 de Abril de 2016, usted consiente el
    tratamiento de los datos de carácter personal por parte de PLAYBOTS EDUCATION, S.L. con la finalidad de llevar a
    cabo el servicio contratado. Los datos recogidos
    serán guardados y custodiados por el plazo estrictamente necesario, o bien, hasta que usted solicite su supresión.
    PLAYBOTS EDUCATION, S.L. tratará los datos
    recogidos con la debida confidencialidad. Si usted se opone al tratamiento de sus datos personales esto haría
    imposible la realización del servicio así como la
    respuesta a sus consultas por escrito. No obstante, Ud. tiene derecho a ejercitar los derechos de acceso,
    rectificación, supresión, limitación y portabilidad,
    en la siguiente dirección; Avenida de las Civilizaciones 15, local 9, Mairena del Aljarafe, Sevilla, rellenando la
    debida solicitud y aportando una copia de su DNI.
    Puede obtener mayor información sobre la Política de Privacidad de PLAYBOTS EDUCATION, S.L. en nuestra página web
    www.playbots.es</p>

  <div class="row">
    <div class="col-sm">
      El alumno (o su representante)
    </div>
    <div class="col-sm">
      Por el centro de enseñanza
    </div>
  </div>
  <div class="row">
    <div class="col-sm">
      <img src="" class="img-signed">
    </div>
    <div class="col-sm">
      <img src="/assets/img/SELLO_FIRMA.png" style="width: 200px; height: 282px;" />
    </div>
  </div>

</div>
<!-- Generar documento recogida menores-->
<div id="pdfAutMenores" [hidden]="objectShow.autRecogida" *ngIf="user && dataSent && courseCurrent">
  <div class="pdfContent-title-center"><b>AUTORIZACIÓN PARA RECOGER A UN MENOR</b></div>
  <p>Yo {{user.fullname}} con D.N.I./N.I.E {{user.numberDNI}} como tutor/tutora legal del alumno/alumna
     {{students[studentCurrent].fullname}} autorizo a D./Dña: {{dataSent.fullname}} con 
     D.N.I./N.I.E. {{dataSent.dni}} a recoger del centro {{courseCurrent?.centerDescr}} a este alumno/alumna.
  </p>
  <br /><br /><br /><br /><br /><br /><br /><br /><br />
  <p>Fdo: D./Dña: <img src="" class="img-signed">
    <!--<input type="text" class="sign-field" style="text-align: left;"/>-->
  </p>
  <p>En {{user.municipality}}, a {{currentDate.getDate()}} de {{arrMeses[currentDate.getMonth()]}} de
    {{currentDate.getFullYear()}}</p>
</div>
<!-- Generar documento para autorización imágenes-->
<div id="pdfAutImagenes" [hidden]="objectShow.autImagenes" *ngIf="user && courseCurrent">
  <div class="pdfContent-title-center"><b>AUTORIZACIÓN PARA LA REALIZACIÓN Y PUBLICACIÓN DE IMÁGENES DE ALUMNOS</b>
  </div>
  <p style="text-align: justify;">
    Con la inclusión de las nuevas tecnologías dentro de los medios didácticos al alcance de la comunidad escolar y la
    posibilidad de que en éstos
    puedan aparecer imágenes de vuestros hijos/as durante la realización de las actividades escolares, y dado que el
    derecho a la propia imagen está
    reconocido en el <b>artículo 18 de la Constitución</b> y regulado por la <b>Ley 1/1982, de 5 de mayo</b>, sobre el
    derecho al honor, a la intimidad personal y
    familiar y a la propia imagen y la <b>Ley Orgánica 3/2018, de 5 de diciembre,</b> de Protección de Datos Personales
    y garantía de los derechos digitales.<br><br>

    La dirección de este Centro pide el consentimiento a los padres o tutores legales para poder realizar y publicar (o
    negarse a la realización y publicación)
    las imágenes en las cuales aparezcan individualmente o en grupo que con carácter pedagógico se puedan realizar a los
    niños/as del centro, en las diferentes
    secuencias y actividades realizadas en el centro y fuera del mismo en actividades extraescolares.
  </p>
  <p>D./Dña. {{user.fullname}}</p>
  <p>con D.N.I./N.I.E {{user.numberDNI}}, como padre/madre/tutor o tutora del alumno/a</p>
  <p>D./Dña. {{students[studentCurrent].fullname}}</p>
  <ul style="list-style: none;">
    <li><input type="checkbox" class="checkbox1" data-excluyente="checkbox2" #checkboxImagenes1 (click)="checkBoxDocumentos(checkboxImagenes2, true, 'imagenes', 'auth')"> <b>Sí doy</b> mi consentimiento para que
      mi hijo/a aparezca en las fotografías que se realicen y se publiquen en la página web del
      centro y sus redes sociales, de forma individual o de grupo, durante la realización de actividades.</li>
    <li>&nbsp;&nbsp;&nbsp;</li>
    <li><input type="checkbox" class="checkbox2" #checkboxImagenes2 (click)="checkBoxDocumentos(checkboxImagenes1, false, 'imagenes', 'auth')"> <b>No doy</b> mi consentimiento para que mi hijo/a aparezca en las
      fotografías que se realicen y se publiquen en la página web del
      centro y sus redes sociales, de forma individual o de grupo, durante la realización de actividades.</li>
    <li>&nbsp;&nbsp;&nbsp;</li>
    <li>Marque con una (&#10003;) lo que proceda</li>
  </ul>
  <p style="text-align: right;">En {{user.municipality}}, a {{currentDate.getDate()}} de
    {{arrMeses[currentDate.getMonth()]}} de {{currentDate.getFullYear()}}</p>
  <br /><br /><br /><br />
  <p style="text-align: right;">
    Firma<br />
    <!--<input type="text" class="sign-field"/>-->
    <img src="" class="img-signed">
  </p>
</div>
<!-- Generar documento para autorización WP-->
<div id="pdfAutWhatsapp" [hidden]="objectShow.autWhatsapp" *ngIf="user && courseCurrent">
  <div class="pdfContent-title-center"><b>INFORMACIÓN SOBRE EL USO DE WHATSAPP COMO VÍA DE CONTACTO</b></div>
  <p><b>Yo, {{user.fullname}} con DNI {{user.numberDNI}}, </b></p>
  <p><b>en calidad de cliente que mantiene una relación contractual con la empresa:</b></p>
  <p><b>(<input type="checkbox" class="autorizo" #checkboxAutorizo (click)="checkBoxDocumentos(undefined, true, 'wp', 'autorizo')" />) AUTORIZO </b> como vía de contacto el número de teléfono facilitado a
    la empresa responsable así como por correo electrónico.
    Cuando la situación lo requiera, se podrá hacer uso de diferentes aplicaciones móviles de mensajería instantánea:
  </p>
  <p><b>● Uso del WHATSAPP de persona física por parte de la empresa:</b></p>
  <p>Actualmente el uso de la app Whatsapp como medio de mensajería vía móvil está a la orden del día, no obstante, nos
    vemos obligados
    a informar a nuestros estimados cliente de lo siguiente:</p>
  <p>Actualmente, <i>Whatsapp</i>, como app perteneciente al grupo de <i>Facebook</i> e <i>Instagram</i>, <b>puede
      vulnerar la privacidad tanto propia como del cliente,</b>
    por lo que, desde un primer momento, recomendamos que cuando se pretenda enviar información más sensible siempre
    prevalecerá el uso de Correo
    Electrónico de la empresa. La empresa responsable no se responsabiliza del uso ilegitimo o abusivo de esta
    aplicación por parte del usuario. </p>
  <p><b>DECLARO;</b> haber sido informado sobre el riesgo existente al hacer uso de esta aplicación móvil:</p>
  <p>(<input type="checkbox" class="informado" data-excluyente="informado2" #checkboxDeclaro1 (click)="checkBoxDocumentos(checkboxDeclaro2, true, 'wp', 'declaro')"/>) ACEPTO
     (<input type="checkbox" class="informado2" #checkboxDeclaro2 (click)="checkBoxDocumentos(checkboxDeclaro1, false, 'wp', 'declaro')" />) NO ACEPTO</p>
  <p><b>CONSIENTO;</b> que esta aplicación “whatsapp” sea la vía de contacto en determinadas ocasiones:</p>
  <p>(<input type="checkbox" class="contacto" data-excluyente="contacto2" #checkboxConsiento1 (click)="checkBoxDocumentos(checkboxConsiento2, true, 'wp', 'consiento')" />) ACEPTO 
    (<input type="checkbox" class="contacto2" #checkboxConsiento2 (click)="checkBoxDocumentos(checkboxConsiento1, false, 'wp', 'consiento')" />) NO ACEPTO</p>
  <p><b><i>Existe la posibilidad de ejercitar los derechos de acceso, rectificación, cancelación y oposición,
        presencialmente e indicándolo por escrito a la
        empresa con domicilio en Avenida Civilizaciones 15 local 9 • 41927 Mairena del Aljarafe, Sevilla o enviando un
        correo al responsable del tratamiento a
        través del siguiente correo electrónico info@playbots.es</i></b></p>
  <br /><br /><br />
  <p>Fdo.:
    <br />
    <!--<input type="text" class="sign-field" style="text-align: left;"/>-->
    <img src="" class="img-signed">
  </p>
  <br /><br /><br />
  <p>En {{user.municipality}}, a {{currentDate.getDate()}} de {{arrMeses[currentDate.getMonth()]}} de
    {{currentDate.getFullYear()}}</p>
</div>
<!-- Generar recibo-->
<div id="pdfRecibo" [hidden]="showPdf" *ngIf="recibo" class="container panel-general">
  <div class="container">
    <div class="panel panel-default">
      <div class="panel-heading panel-defaul-color">
        <label class="generic-label col-form-label"></label>
      </div>
      <div class="panel-body panel-body-color">
        <div class="row">
          <div class="col-sm-5 imagen-center paddingbanner-imagen">
            <img class="product-image" width="200px" height="130px" [src]="'/assets/img/logoPB_150px.png'" />
          </div>
          <div class="col-sm-4 paddingbaner-central">
            <label class="generic-label">Playbots Education S.L.</label><br>
            <label class="generic-label">Avda. de las Civilizaciones 15, local 9</label><br>
            <label class="generic-label">41927 Mairena del Aljarafe, Sevilla</label><br>
            <label class="generic-label">CIF B90351719</label><br>
            <label class="generic-label">info@playbots.es</label><br>
          </div>
          <div class="col-sm-3 paddingbanner">
            <h3 class="generic-label">Recibo</h3>
            <label class="generic-label label-decoration">Fecha de emisión</label><br>
            <label class="generic-label">{{recibo.emissionDate}}</label><br>
            <label class="generic-label label-decoration">Nº de documento</label><br>
            <label class="generic-label">{{recibo.numberReceipts}}</label><br>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <br>
  <div class="container">
    <div class="row content-wrapper">
      <div class="col-sm" *ngIf="recibo.tutor">
        <label class="">Cliente</label>
        <hr><br>
        <label class="generic-label">{{recibo.tutor.nombre}}</label><br>
        <label class="generic-label">{{recibo.tutor.document}} {{recibo.tutor.numberDNI}}</label><br>
        <label class="generic-label">{{recibo.tutor.address}} {{recibo.tutor.number}}</label><br>
        <label class="generic-label">{{recibo.tutor.zip}} {{recibo.tutor.municipality}}, Sevilla
          {{recibo.tutor.cityTitular}}</label><br>
        <label class="generic-label">{{recibo.tutor.email}}</label><br>
      </div>
      <div class="col-sm" *ngIf="recibo.student">
        <label class="">Alumno</label>
        <hr><br>
        <label class="generic-label">{{recibo.student.nombre}}</label><br>
        <label class="generic-label">{{recibo.student.codeCourse}}</label><br>
        <label class="generic-label">{{recibo.student.course}}</label><br>
        <label class="generic-label">{{recibo.student.center}}</label><br>
      </div>
    </div>
  </div>
  <br>
  <br>
  <div class="container">
    <div class="row form-container content-wrapper">
      <div class="col-12 table-wrapper-recibo table-responsive">
        <table class="table table-borderless table-striped">
          <thead>
            <th class="panel-defaul-color-table" style="width: 290px;;">Descripción</th>
            <th class="panel-defaul-color-table">Precio Unitario</th>
            <th class="panel-defaul-color-table">Descuento</th>
            <th class="panel-defaul-color-table">Precio</th>
          </thead>
          <tbody>
            <tr *ngFor="let element of this.recibo.conceptos">
              <td>{{element.description}} </td>
              <td>{{element.precioUnitario}} </td>
              <td>{{element.descuento}} % </td>
              <td>{{element.precio}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br>
  <br>
  <div class="container">
    <div class="row content-wrapper">
      <div class="col-sm" *ngIf="recibo.tutor">
        <label class="generic-label">Método de pago: {{recibo.tutor.paymentMethod}}</label><br>
        <label class="generic-label">Estado: {{recibo.estado}}</label><br>
        <label *ngIf="recibo.tutor.IBAN" class="generic-label">IBAN: {{recibo.tutor.IBAN}}</label><br>
      </div>
      <div class="col-sm" *ngIf="recibo.student">
        <div class="row">
          <div class="col-sm">
            Total Parcial:<br><br>
            IVA:<br><br>
            Total impuestos:<br><br>
            Pagado:<br></div>
          <div class="col-sm label-rigth total">
            <label class="label-pdf"> {{recibo.totalParcial}}€</label>
            <hr><br>
            <label class="label-pdf"> {{recibo.iva}}%</label>
            <hr><br>
            <label class="label-pdf"> {{recibo.impuestos}}€</label>
            <hr><br>
            <hr><label class="label-pdf"> {{recibo.totalParcial}}€</label>
            <hr><br>
          </div>
        </div>

      </div>
    </div>
  </div>
  <br>
  <br>
  <div class="container panel panel-default">
    <div class="panel-heading panel-defaul-color">
      <label class="generic-label col-form-label"></label>
    </div>
  </div>

</div>
<app-signature [hidden]="showFirma" id="signature"></app-signature>
<div *ngIf="cargando" class="cargando">
  <mat-spinner></mat-spinner>
</div>